<button
	type="button"
	[tooltip]="tooltipText"
	[placement]="placement"
	container="body"
	[adaptivePosition]="false"
	class="app-button-icon"
	[class.outline]="isOutline"
	[class.secondary]="isSecondary"
	[disabled]="disabled"
	(click)="clickHandler.emit($event)"
>
	<ng-content></ng-content>
</button>
